import React from 'react';
import { EyeTestExplanation } from '../views/eye-test-explanation';
import { ContrastTestExplanation } from '../views/contrast-test-explanation';
import { VidebisTest } from '../../shared/util/types';
import { TextTestExplanation } from '../views/text-test-explanation';
import { MichelsonTestExplanation } from '../views/michelson-test-explanation';
import { getQuery } from '../../shared/util/functions';
import { postTelemetry } from '../../result/util/axios';

interface Props {
    history: any;
    location: any;
}

interface State {
    step: number;
    testType: VidebisTest;
}

export class TestExplanationController extends React.PureComponent<Props, State> {

    state: State = {
        step: 1,
        testType: 'eye-test'
    };

    componentDidMount(): void {
        const query = getQuery(this.props.location.search);
        const testType: VidebisTest = query.test;
        if (!['eye-test', 'contrast-test', 'michelson-test', 'text-test'].includes(testType)) {
            // We don't have a step 6 anymore (Test Picker). Until we don't enable it again we probably want to link
            // back to the first page.
            // this.props.history.push('/setup?step=6');
            this.props.history('/setup?step=1');
        } else {
            this.setState({ testType: testType as VidebisTest });
        }
    }

    private startTest = (): void => {
        postTelemetry(this.getTestName(), { data: 'start' });
        let url = `/test?type=${this.state.testType}`;
        const query = getQuery(this.props.location.search);
        if (query['all-tests']) {
            url += `&all-tests=true`;
        }
        this.props.history.push(url);
    }

    private getTestName = (): string => {
        const { test } = getQuery(this.props.location.search);
        if (test === 'eye-test') {
            return 'visus';
        } else if (test === 'contrast-test') {
            return 'contrast';
        } else if (test === 'michelson-test') {
            return 'michelson';
        } else {
            return 'vergroesserungsbedarf';
        }
    }

    private goBack = (): void => {
        this.props.history.push('/setup?step=5');
    };

    private getTest = (): any => {
        if (this.state.testType === 'eye-test') {
            return <EyeTestExplanation onPress={this.startTest} onBack={this.goBack} />;
        } else if (this.state.testType === 'contrast-test') {
            return <ContrastTestExplanation onPress={this.startTest} onBack={this.goBack} />;
        } else if (this.state.testType === 'michelson-test') {
            return <MichelsonTestExplanation onPress={this.startTest} onBack={this.goBack} />;
        } else {
            return <TextTestExplanation onPress={this.startTest} onBack={this.goBack} />;
        }
    };

    render() {
        return (
            <main className={"test-explanation--container"}>
                {this.getTest()}
            </main>
        );
    }
}
